import styled from 'styled-components';

export const StackStyled = styled('div')<any>`
  display: flex;
  box-sizing: border-box;
`;
